export function dropdown(ctx) {
    return {
        styles: {
            main: { ...ctx.pretty, radius: 5, text_font: 32, text_color: '#ffffff', padding: 0 },
            item_buttons: {
                bg_color:     '#000000',
                border_color: '#ffffff',
                border_width: 2,
                radius:       5,
                text_color:   '#ffffff',
                padding:      0,
            },
            selected: { bg_color: '#ffffff' },
        },
    };
}
